import script from "./GenerateSnippetTagDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateSnippetTagDialog.vue?vue&type=script&setup=true&lang=js"

import "./GenerateSnippetTagDialog.vue?vue&type=style&index=0&id=e44ae510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e44ae510"]])

export default __exports__